import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";
import RankingModal from "../Components/Modals/RankingComponents/RankingModal";

type Props = NativeStackScreenProps<RootStackParamList, "Ranking">;

const RankingScreen: React.FC<Props> = ({ navigation }) => {
  return <RankingModal onClose={() => navigation.goBack()} />;
};

export default RankingScreen;
